import React from 'react';

interface LogoProps {
  width?: number;
  height?: number;
  variant?: 'horizontal' | 'vertical';
}

const Logo: React.FC<LogoProps> = ({ width = 80, height = 80, variant = 'horizontal' }) => {
  const logoSrc = variant === 'horizontal' 
    ? '/assets/logo/logo-white.webp'
    : '/assets/logo/logo-vertical.webp';

  return (
    <div className="logo">
      <a href="/" className="block">
        <img
          src={logoSrc}
          alt="Phim 3s"
          title="Phim 3s"
          style={{ width, height }}
          className={`logo-${variant}`}
        />
      </a>
    </div>
  );
};

export default Logo;
